import { AkinatorCompletion, Suggestion } from 'types/suggestions';

export const isAkinatorCompletion = (
  item: Suggestion | AkinatorCompletion | null | undefined,
): item is AkinatorCompletion => {
  if (!item) return false;

  return 'type' in item && (item.type === 'CONTINUE' || item.type === 'REPLACE');
};
